module.exports = __webpack_public_path__ + "img/metting.4c8bf105.png";